import gql from "graphql-tag";

export default gql`
  query QuotesHistory($tickerSymbols: [TickerSymbol!]!, $startDate: Date!, $endDate: Date!) {
    quotesHistory(tickerSymbols: $tickerSymbols, startDate: $startDate, endDate: $endDate) {
      tickerSymbol
      nodes {
        tickerSymbol
        date
        close
        numberOfTrades
        volumeTraded
        financialVolume
      }
    }
  }
`;
